import { createApp } from 'vue';
import PrintDropdown from '../components/PrintDropdown';

if (document.getElementById('print-dropdown')) {
    const app = createApp({
        components: {
            PrintDropdown
        },
    });

    app.mount('#print-dropdown');
}